import { useMutation } from "@tanstack/react-query";
import { ProviderGroupControllerApi, TwilioCallerId } from "../../services";
import { getConfigObject } from "../../utils/utils";

interface Params {
  providerGroupId: string;
  twilioCallerId: TwilioCallerId;
  xTENANTID?: string;
}

/**
 * @author Rajkumar Rathod
 */
export const useSetCallerId = () =>
  useMutation({
    mutationFn: async (params: Params) =>
      new ProviderGroupControllerApi(
        getConfigObject()
      ).setProviderGroupCallerId(
        params?.providerGroupId,
        params?.twilioCallerId,
        params?.xTENANTID
      ),
  });
